import React from 'react';
import {observer} from "mobx-react";
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {GameInfo} from '../../../../../../services/games/game-info';
import {FlexGrowItemBox} from '../../../../../../themes/architecture/css-helpers/flex';
import {VideoTileOverlayComponent} from '../../../../../live-streaming-tile/video-common-components/video-tile-overlay/video-tile-overlay.component';
import {LiveStreamSlidePlayerContainer} from './boxes/live-stream-slide-player.box';

interface LiveStreamSlidePlayerProps {
    gameInfo: GameInfo;
}
export const LiveStreamSlidePlayerComponent: React.FC<LiveStreamSlidePlayerProps> = observer((props) => {
    const services = useServices();
    const liveStreamPlaying = services.liveStreamPlaying;
    return (
        <>
            <FlexGrowItemBox ></FlexGrowItemBox>
            <LiveStreamSlidePlayerContainer
                gameInfo={props.gameInfo}
                muted={liveStreamPlaying.isVideoMuted}
                isInCenterStage={true}
                inViewport={true}
                display={true}
                videoPlayingService={liveStreamPlaying}
                onWatchTimeLimitReached={() => {}} //TODO we will have a task for videoPlayer
                onLoading={() => {}} //TODO we will have a task for videoPlayer
                onError={() => {}} //TODO we will have a task for videoPlayer
            />
            <FlexGrowItemBox ></FlexGrowItemBox>
            <VideoTileOverlayComponent
                videoPlayingService={liveStreamPlaying}
                videoPlaying={true}
            />
        </>
    )
});
